import { sendRequestJson } from '../../utils'

export class AllergenRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async allergensList() {
		const url = this.urlBase + '/world/api/allergens/list'
		try {
			return await sendRequestJson({ data: null, url, method: 'GET' })
		} catch (e) {
			console.log('Ups, algo ha ido mal obteniendo los alergenos.')
		}
	}
}

export const allergenRepository = new AllergenRepository()
